import { Service } from '@/lib'
import { useState } from 'react'

export const useService = <T>(Service: T) => {
  const [service] = useState<T>(Service)
  return service
}
